window.PetOlivePageScrollLock = window.PetOlivePageScrollLock || (() => {
  const owners = new Set();
  let scrollY = 0;
  let previousStyles = null;

  const lock = (owner) => {
    if (owners.has(owner)) return;
    owners.add(owner);
    if (owners.size > 1) return;

    const body = document.body;
    const root = document.documentElement;
    scrollY = window.scrollY;
    previousStyles = {
      rootOverflow: root.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
    };

    root.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  };

  const unlock = (owner) => {
    if (!owners.delete(owner) || owners.size > 0 || !previousStyles) return;

    const body = document.body;
    const root = document.documentElement;
    root.style.overflow = previousStyles.rootOverflow;
    body.style.overflow = previousStyles.bodyOverflow;
    body.style.position = previousStyles.bodyPosition;
    body.style.top = previousStyles.bodyTop;
    body.style.left = previousStyles.bodyLeft;
    body.style.right = previousStyles.bodyRight;
    body.style.width = previousStyles.bodyWidth;
    previousStyles = null;
    window.scrollTo(0, scrollY);
  };

  return { lock, unlock };
})();

(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const syncDrawerLock = () => {
    if (drawer.classList.contains('active')) {
      window.PetOlivePageScrollLock.lock('cart-drawer');
    } else {
      window.PetOlivePageScrollLock.unlock('cart-drawer');
    }
  };

  new MutationObserver(syncDrawerLock).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncDrawerLock();
})();
